var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "5" } },
        [
          _c("ContractSummary", {
            staticClass: "mt-2",
            attrs: {
              contract: _vm.contract,
              contractCategories: _vm.contractCategories
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "7" } }, [
        _c("p", { staticClass: "text-muted mt-2" }, [
          _vm._v("\n      " + _vm._s(_vm.infoText) + "\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-wrap cursorBcard" },
          _vm._l(_vm.contactPersons, function(contactPerson) {
            return _c(
              "div",
              {
                key: contactPerson.id,
                staticClass:
                  "p-0 my-2 mr-3 rounded-0 btn-estate-administration",
                attrs: { variant: "transparent" },
                on: {
                  click: function($event) {
                    _vm.onSelectContactPerson(contactPerson)
                  }
                }
              },
              [
                _c("BusinessCard", {
                  staticClass: "rounded-0",
                  class: _vm.getPotClass(contactPerson),
                  attrs: {
                    size: "sm",
                    name:
                      contactPerson.firstName + " " + contactPerson.lastName,
                    relation: contactPerson.relation,
                    imageSrc: contactPerson.avatarUuid
                  }
                })
              ],
              1
            )
          })
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7cf6b14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7cf6b14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractEstateDetails.vue
// module id = Dq92
// module chunks = 1